import { render, staticRenderFns } from "./StatCard.vue?vue&type=template&id=57ff0b7c&scoped=true"
import script from "./StatCard.vue?vue&type=script&lang=js"
export * from "./StatCard.vue?vue&type=script&lang=js"
import style0 from "./StatCard.vue?vue&type=style&index=0&id=57ff0b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff0b7c",
  null
  
)

export default component.exports